
import { defineComponent, watch, computed, reactive, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';

export default defineComponent({
    setup() {
        const store = useStore();
        const route = useRoute();
        const router = useRouter();
        const menu = computed(() => store.state.user.menu);
        const showBackIcon = ref();
        const singlePage = [{
            path: '/person',
            meta: {
                title: '个人筛查',
            },
            children: [{
                path: '/historyresult',
                meta: {
                    title: '历史筛查结果',
                    isMenu: true,
                }
            }]
        },
        {
            path: '/result',
            meta: {
                title: '筛查记录',
            },
            children: [{
                path: '/screeningresults',
                meta: {
                    title: '筛查结果',
                }
            }]
        },
        {
            path: '/schoolscreening',
            meta: {
                title: '校园筛查',
                isMenu: true,
            },
            children: [{
                path: '/newmassscreening',
                meta: {
                    title: '筛查计划',
                },
                children: [{
                    path: '/massscreening/columbaresult',
                    meta: {
                        title: '筛查详情',
                    },
                    children: [{
                        path: '/scheduleresults',
                        meta: {
                            title: '筛查结果',
                        }
                    }],
                }]
            }, {
                path: '/newschool',
                meta: {
                    title: '学生管理'
                },
                children: [{
                    path: '/historyresult',
                    meta: {
                        title: '历史筛查结果'
                    }
                }]
            }]
        },
        ];
        const currentList = reactive([]);
        const findeParents = (path, list) => {
            return list.filter((item) => {
                const isCurrent = item.path === path;
                currentList.push({
                    path: item.path,
                    name: item.meta.title,
                    isMenu: item.meta.isMenu,
                });
                try {
                    if (isCurrent) {
                        throw new Error('break');
                    }
                } catch (error) {

                }
                if (item.children) {
                    const childHasPath = findeParents(path, item.children).length > 0;
                    if (!childHasPath) {
                        currentList.splice(currentList.length - 1, 1);
                    }
                }
                if (!item.children && !isCurrent) {
                    currentList.splice(currentList.length - 1, 1);
                }
                return isCurrent;
            });
        };
        const backToPage = (item) => {
            if (item.path === currentList[currentList.length - 1].path) {
                return;
            }
            if (!item.isMenu) {
                router.push({ path: item.path });
            }
        };
        const backToPre = () => {
            router.push({ path: currentList[showBackIcon.value].path });
        };
        watch(() => route, (val) => {
            const findPath = val.path;
            currentList.length = 0;
            try {
                findeParents(findPath, singlePage);
                if (currentList.length === 0) {
                    findeParents(findPath, menu.value);
                }
            } catch (err) {
                console.log(err);
            }
            showBackIcon.value = undefined;
            currentList.forEach((item, index) => {
                if (!item.isMenu && currentList.length - 1 !== index) {
                    showBackIcon.value = index;
                }
            });
        }, {
            deep: true,
            immediate: true,
        });
        return {
            currentList,
            showBackIcon,
            backToPre,
            backToPage,
        };
    }
});
